import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import remove from './remove.js'
import wrapper from './wrapper.js'

export default contract({
  remove: array([
    remove
  ]),
  wrapper: array([
    wrapper
  ])
})